// @flow
import React, { Component, Fragment } from 'react';
import MainHead from 'components/main/MainHead';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { type ContextRouter, withRouter } from 'react-router-dom';
import type { State } from 'store';
import { BaseActions } from 'store/actionCreators';
import type { UserData } from 'store/modules/user';
import RightCorner from 'containers/base/RightCorner';

type Props = {
  user: ?UserData,
  userMobileMenu: boolean,
} & ContextRouter;

class MainHeadContainer extends Component<Props> {
  onBurgerMenuClick = () => {
    BaseActions.showMobileUserMenu();
    document.body.style.overflowY = 'hidden';
    // else document.body.style.overflowY = '';
  };

  onClickOutside = () => {
    BaseActions.hideMobileUserMenu();
    document.body.style.overflowY = '';
  };

  render() {
    const { user, windowWidth, userMobileMenu } = this.props;

    return (
      <MainHead
        logged={!!user}
        user={user}
        rightArea={user && <RightCorner />}
        windowWidth={windowWidth}
        showUserMobileMenu={userMobileMenu}
        onBurgerMenuClick={this.onBurgerMenuClick}
        onClickOutside={this.onClickOutside}
      />
    );
  }
}

export default compose(
  withRouter,
  connect(
    ({ user, base }: State) => ({
      user: user.user,
      userMobileMenu: base.userMobileMenu,
    }),
    () => ({}),
  ),
)(MainHeadContainer);



// WEBPACK FOOTER //
// ./src/containers/main/MainHeadContainer.js